<template>
  <div
    v-show="this.$store.state.layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${this.$store.state.darkMode ? 'bg-transparent' : 'bg-transparent'}`"
  />
  <div class="sidenav-overlay" @click="closeMobileDrawer"></div>
  <aside
    class="overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs"
    :class="[
      `${this.$store.state.isRTL ? 'rotate-caret fixed-end' : 'fixed-start'}
      ${
        this.$store.state.layout === 'landing' ? 'bg-dark shadow-none' : ' '
      } ${this.$store.state.sidebarType}`,
      { 'sidenav--collapsed': this.$store.state.sidebarCollapsed },
    ]"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <router-link class="m-0 navbar-brand" to="/dashboard">
        <img
          :src="
            this.$store.state.darkMode ||
            this.$store.state.sidebarType === 'bg-default'
              ? logoWhite
              : logo
          "
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
        <span class="ms-2 font-weight-bold me-2">Green Mushroom</span>
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="custom_class" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/mushrooms-green.png";
import logoWhite from "@/assets/img/mushrooms-green.png";

export default {
  inheritAttrs: false,
  name: "indexComponent",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      logoWhite,
    };
  },
  props: ["custom_class", "layout"],
  methods: {
    closeMobileDrawer() {
      document.getElementById("app")?.classList.remove("sidenav-mobile-open");
    },
  },
};
</script>
